export default __webpack_public_path__ + "static/media/Nerd_Rains.f3ba2a98.png";